import React from 'react'
import tw, { styled } from "twin.macro"
import classNames from "classnames";

interface Props {
  autoHeightResponsive?: boolean
  autoHeight?: boolean
  anchor?: string
  fullHeight?: boolean
}

const SlideSection: React.SFC<Props> = ({ children, fullHeight, autoHeightResponsive, autoHeight, anchor }) => 
  <div data-anchor={anchor} className={classNames('section', {
    'fp-auto-height': autoHeight,
    'fp-auto-height-responsive': autoHeightResponsive,
    'h-full': fullHeight
  })}>
    <div css={[fullHeight && tw`h-full`]}>
      {children}
    </div>
  </div>


export default SlideSection;
